"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonPaymentTermLabels = exports.CommonPaymentTerms = void 0;
exports.CommonPaymentTerms = [0, 7, 15, 30, 45, 60];
exports.CommonPaymentTermLabels = {
    0: 'Net 0',
    7: 'Net 7',
    15: 'Net 15',
    30: 'Net 30',
    45: 'Net 45',
    60: 'Net 60',
};
//# sourceMappingURL=payment-term.js.map